import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
// import Header from "./components/Header";

import HomeScreen from "./screens/HomeScreen";
import ContactScreen from "./screens/ContactScreen";

function App() {
  return (
    <Router>
      <div className="App">
        <Route path="/" component={HomeScreen} exact />
        <Route path="/contact" component={ContactScreen} />
      </div>
    </Router>
  );
}

export default App;
